export default "__VITE_ASSET__2cd28998__"